// extracted by mini-css-extract-plugin
export default {"container":"burger-element_container__BxCaM"};